<svelte:head>
    <link rel="preconnect" href="https://fonts.googleapis.com">
    <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
    <link href="https://fonts.googleapis.com/css2?family=Inconsolata:wght@700&display=auto" rel="stylesheet">
    <link href="https://fonts.googleapis.com/css2?family=Open+Sans+Condensed:wght@300&display=auto" rel="stylesheet">
    <link href="https://fonts.googleapis.com/css2?family=Monoton&display=block" rel="stylesheet">
    <link href="https://fonts.googleapis.com/css2?family=Poppins:wght@300&display=swap" rel="stylesheet">
    <link href="https://fonts.googleapis.com/css2?family=Roboto:wght@500&display=swap" rel="stylesheet">
    <script src="https://kit.fontawesome.com/aeceeaf96c.js" crossorigin="anonymous"></script>
</svelte:head>

<script>
    import Router from 'svelte-spa-router';
    import routes from './routes';
    import Navbar from "./Navbar.svelte";
    import {user} from "./auth/auth";
</script>
<Navbar {user}/>

<Router {routes} />

<style>

    :global(body) {
        background-color: #1D1313;
        padding: 0;
    }

</style>